import classNames from "classnames";
import React, { useId } from "react";
import { createPortal } from "react-dom";
import ReactToolTip from "react-tooltip";
import style from "../../scss/export.module.scss";
import { getContentTarget } from "../../utils";
import "./tooltip.scss";

export type TTooltip = {
    children: React.ReactNode;
    toolTipContent: string | JSX.Element;
    triggerOnClick?: boolean;
    clickable?: boolean;
    manuallyHideToolTip?: boolean;
    className?: string;
    normalFontSize?: boolean;
    wrapperClassName?: string;
    pointerCursor?: boolean;
};

export const Tooltip = ({
    children,
    toolTipContent,
    triggerOnClick = false,
    clickable = true,
    manuallyHideToolTip = false,
    className,
    normalFontSize = false,
    wrapperClassName,
    pointerCursor = false,
}: TTooltip) => {
    const id = useId();

    let cursor = "initial";

    if (triggerOnClick || pointerCursor) {
        cursor = "pointer";
    }

    return (
        <>
            <span style={{ display: "inline-block", cursor }} className={wrapperClassName} data-tip data-for={id}>
                {children}
            </span>
            {!manuallyHideToolTip &&
                createPortal(
                    <ReactToolTip
                        id={id}
                        effect="solid"
                        className={classNames("c-tooltip", className, {
                            "c-tooltip--normal-fs": normalFontSize,
                        })}
                        backgroundColor={style.whiteColor}
                        textColor={style.blackColor}
                        border={true}
                        borderColor={style.midBlueColor}
                        event={triggerOnClick ? "click" : ""}
                        globalEventOff={triggerOnClick ? "click" : ""}
                        delayShow={triggerOnClick ? 0 : 200}
                        delayHide={triggerOnClick ? 0 : 200}
                        clickable={clickable}
                    >
                        {toolTipContent}
                    </ReactToolTip>,
                    getContentTarget()
                )}
        </>
    );
};

export default Tooltip;
